import {
  Button,
  Checkbox,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import {Box} from "@mui/system";
import React from "react";
import {Controller, useFormContext} from "react-hook-form";
import MWCaption from "../../components/MWCaption";
import {useConvertBase64} from "../../hooks/useConvertBase64";
import {
  SelectType,
  daysOfWorkValue,
  pressureUnitValue,
  typeValue,
  workHoursForDayValue,
} from "../../models/clientModels/data/selectList";
import {StyledInput, StyledInputFile} from "../../styledComponents/StyledListItemButton";

import DeleteIcon from "@mui/icons-material/Delete";
import {
  FormContents,
  FormSection,
  InputFileContainer,
  ReliabilityToggle,
  StyledTrustCheck,
  StyledTrustCheckContainer,
} from "../../styledComponents/StyledCreateForm";

import AttachmentIcon from "@mui/icons-material/Attachment";
import ConstructionIcon from "@mui/icons-material/Construction";
import InfoIcon from "@mui/icons-material/Info";
import MWClientSelectBox from "../../components/MWClientSelectBox";
import MWDatePicker from "../../components/MWDatePicker";
import MWInputFile from "../../components/MWInputFile";
import MWTextField from "../../components/MWTextField";
type EquipmentProps = {
  captionColor?: string;
};

const EquipmentForm = ({captionColor}: EquipmentProps) => {
  const {convertChangeHandler, image} = useConvertBase64();

  const isMobile = useMediaQuery("(max-width: 780px)");

  //note 리액트 훅 폼
  const methods = useFormContext();

  const {
    setValue,
    getValues,
    watch,
    control,
    formState: {errors},
  } = methods;

  return (
    <React.Fragment>
      <FormSection>
        <MWCaption title={"설비정보 1"} color={captionColor} icon={<InfoIcon />} />
        <FormContents container rowSpacing={2}>
          <Grid item xs={12} sm={12} lg={6}>
            <MWTextField name="installLocation" label="설비위치" />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <MWTextField name="personName" label="설비책임자" />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <MWClientSelectBox<SelectType> name="type" label="설비분류" data={typeValue} />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <MWTextField name="identifyNumber" label="설비번호" />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <MWTextField name="name" label="설비명" />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <MWTextField name="manufacture" label="제작사" />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <MWTextField name="modelNo" label="Model" />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <MWTextField name="serialNo" label="serialNo" />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <MWTextField name="price" label="구매금액(천원)" />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <MWTextField name="eqLevel" label="설비등급" />
          </Grid>
          <StyledTrustCheckContainer>
            <StyledTrustCheck container>
              <ReliabilityToggle>
                <Controller
                  name="hasReliability"
                  control={control}
                  render={({field}) => (
                    <StyledInput>
                      <label>신뢰성 확인 : </label>
                      <Checkbox
                        id="hasReliability"
                        onChange={(e) => field.onChange(e.target.checked)}
                        checked={field.value}
                      />
                    </StyledInput>
                  )}
                />
              </ReliabilityToggle>
              <Grid item xs={12} sm={12} lg={4}>
                <Controller
                  name="lifeTime"
                  control={control}
                  render={({field}) => (
                    <Box sx={{display: "flex", alignItems: "center", margin: "20px"}}>
                      <label htmlFor="lifeTime" style={{minWidth: "120px"}}>
                        설비수명(hr) :
                      </label>
                      <TextField
                        {...field}
                        id="lifeTime"
                        // label="설비수명(hr)"
                        size="small"
                        disabled={!watch("hasReliability")}
                      />
                    </Box>
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={4}>
                <Controller
                  name="daysOfWork"
                  control={control}
                  render={({field}) => (
                    <Box sx={{display: "flex", alignItems: "center", margin: "20px"}}>
                      <label htmlFor="daysOfWork" style={{minWidth: "120px"}}>
                        가동주기 :
                      </label>
                      <Select
                        {...field}
                        labelId="daysOfWork"
                        id="daysOfWork"
                        size="small"
                        fullWidth
                        defaultValue={field.value}
                        disabled={!watch("hasReliability")}
                      >
                        <MenuItem disabled value={field.value} style={{display: "none"}}></MenuItem>
                        {daysOfWorkValue.map((item) => (
                          <MenuItem key={item.value} value={item.value}>
                            {item.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={4}>
                <Controller
                  name="workHoursForDay"
                  control={control}
                  render={({field}) => (
                    <Box sx={{display: "flex", alignItems: "center", margin: "20px"}}>
                      <label htmlFor="workHoursForDay" style={{minWidth: "120px"}}>
                        일 가동시간 :
                      </label>
                      <Select
                        {...field}
                        labelId="workHoursForDay"
                        id="workHoursForDay"
                        fullWidth
                        size="small"
                        defaultValue={field.value}
                        disabled={!watch("hasReliability")}
                      >
                        <MenuItem disabled value={field.value} style={{display: "none"}}></MenuItem>
                        {workHoursForDayValue.map((item) => (
                          <MenuItem key={item.value} value={item.value}>
                            {item.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                  )}
                />
              </Grid>
            </StyledTrustCheck>
            <Box>
              <Controller
                name="isPSM"
                control={control}
                render={({field}) => (
                  <StyledInput>
                    <label>PSM 대상여부 : </label>
                    <Checkbox id="isPSM" checked={field.value} onChange={field.onChange} />
                  </StyledInput>
                )}
              />
            </Box>
          </StyledTrustCheckContainer>
        </FormContents>
      </FormSection>
      <FormSection>
        <MWCaption title={"설비정보 2"} color={captionColor} icon={<ConstructionIcon />} />
        <FormContents container rowSpacing={2}>
          <Grid item xs={12} sm={12} lg={6}>
            <MWTextField name="checkTermMonth" label="점검(교정)주기" />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <MWTextField name="capacity" label="용량" />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <MWDatePicker name="installDate" label="설치일자" />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <MWTextField name="law" label="법적대상" />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <MWDatePicker name="nextDate" label="점검기준일" />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <MWTextField name="wideLevel" label="방폭등급" />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <Controller
              name="drivePressure"
              control={control}
              render={({field, fieldState: {error}}) => (
                <Grid container alignItems="center" justifyContent="flex-start">
                  <Grid
                    item
                    xs={0}
                    sm={0}
                    md={3}
                    lg={3}
                    xl={3}
                    sx={{display: {xs: "none", sm: "none", md: "block"}}}
                  >
                    <label htmlFor="drivePressure">압력(운전) : </label>
                  </Grid>
                  <Grid item xs={9} sm={9} md={5} lg={5} xl={5}>
                    <TextField
                      {...field}
                      id="drivePressure"
                      label="압력(운전)"
                      size="small"
                      placeholder="압력(운전)"
                    />
                    <Typography color="secondary">{error?.message}</Typography>
                  </Grid>
                  <Grid item xs={3} sm={3} md={4} lg={4} xl={4}>
                    <Controller
                      name="pressure1Unit"
                      control={control}
                      render={({field}) => (
                        <Select
                          {...field}
                          sx={{marginLeft: "4px", width: {xs: "100%", sm: "100%", md: "auto"}}}
                          labelId="pressure1Unit"
                          id="pressure1Unit"
                          size="small"
                          defaultValue={field.value}
                        >
                          <MenuItem
                            disabled
                            value={field.value}
                            style={{display: "none"}}
                          ></MenuItem>
                          {pressureUnitValue.map((item) => (
                            <MenuItem key={item.value} value={item.value}>
                              {item.label}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                  </Grid>
                </Grid>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <Controller
              name="designPressure"
              control={control}
              render={({field, fieldState: {error}}) => (
                <Grid container alignItems="center" justifyContent="flex-start">
                  <Grid
                    item
                    xs={0}
                    sm={0}
                    md={3}
                    lg={3}
                    xl={3}
                    sx={{display: {xs: "none", sm: "none", md: "block"}}}
                  >
                    <label htmlFor="designPressure">압력(설계) : </label>
                  </Grid>
                  <Grid item xs={9} sm={9} md={5} lg={5} xl={5}>
                    <TextField
                      {...field}
                      id="designPressure"
                      label="압력(설계)"
                      size="small"
                      placeholder="압력(설계)"
                    />
                    <Typography color="secondary">{error?.message}</Typography>
                  </Grid>
                  <Grid item xs={3} sm={3} md={4} lg={4} xl={4}>
                    <Controller
                      name="pressure2Unit"
                      control={control}
                      render={({field}) => (
                        <Select
                          {...field}
                          sx={{marginLeft: "4px", width: {xs: "100%", sm: "100%", md: "auto"}}}
                          labelId="pressure2Unit"
                          id="pressure2Unit"
                          size="small"
                          defaultValue={field.value}
                        >
                          <MenuItem
                            disabled
                            value={field.value}
                            style={{display: "none"}}
                          ></MenuItem>
                          {pressureUnitValue.map((item) => (
                            <MenuItem key={item.value} value={item.value}>
                              {item.label}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                  </Grid>
                </Grid>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <MWTextField name="driveTemperature" label="온도(운전)⁰C" />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <MWTextField name="designTemperature" label="온도(설계)⁰C" />
          </Grid>
        </FormContents>
      </FormSection>
      <FormSection>
        <MWCaption
          title={"첨부파일 - 1MB 미만의 파일만 가능합니다"}
          color={captionColor}
          icon={<AttachmentIcon />}
        />
        <InputFileContainer container rowSpacing={2}>
          {isMobile ? (
            <MWInputFile
              file="processDocumentBase64"
              fileName="processDocument"
              buttonLabel="점검정비절차서"
            />
          ) : (
            <Box sx={{width: "100%"}}>
              <Controller
                name="processDocumentBase64"
                control={control}
                render={({field: {onChange, name}}) => (
                  <StyledInputFile>
                    <label style={{cursor: "pointer"}} htmlFor="processDocumentBase64">
                      점검정비 절차서 :
                    </label>
                    <Button variant="contained" component="label" size="small">
                      파일 업로드
                      <TextField
                        sx={{display: "none"}}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                          convertChangeHandler(event, setValue, name, "processDocument")
                        }
                        type="file"
                        id="processDocumentBase64"
                        size="small"
                        hidden
                      />
                    </Button>
                    <p>{getValues("processDocument")}</p>
                    <IconButton
                      aria-label="delete"
                      color="secondary"
                      onClick={() => {
                        setValue("processDocument", "");
                        setValue("processDocumentBase64", "");
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>

                    {/* <Typography>{errors.processDocumentBase64.message}</Typography> */}
                  </StyledInputFile>
                )}
              />
            </Box>
          )}
          {isMobile ? (
            <MWInputFile
              file="certificationBase64"
              fileName="certification"
              buttonLabel="인증서류 외"
            />
          ) : (
            <Box sx={{width: "100%"}}>
              <Controller
                name="certificationBase64"
                control={control}
                render={({field: {onChange, name}}) => (
                  <StyledInputFile>
                    <label style={{cursor: "pointer"}} htmlFor="certificationBase64">
                      인증서류 외 :
                    </label>
                    <Button variant="contained" component="label" size="small">
                      파일 업로드
                      <TextField
                        sx={{display: "none"}}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                          convertChangeHandler(event, setValue, name, "certification")
                        }
                        type="file"
                        id="certificationBase64"
                        size="small"
                        hidden
                      />
                    </Button>
                    <p>{getValues("certification")}</p>
                    <IconButton
                      aria-label="delete"
                      color="secondary"
                      onClick={() => {
                        setValue("certificationBase64", "");
                        setValue("certification", "");
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                    {/* {errors.certificationBase64 && (
                    <Typography>{errors.certificationBase64.message}</Typography>
                  )} */}
                  </StyledInputFile>
                )}
              />
            </Box>
          )}
          {isMobile ? (
            <MWInputFile file="pAndIDBase64" fileName="pAndID" buttonLabel="관련P&ID" />
          ) : (
            <Box sx={{width: "100%"}}>
              <Controller
                name="pAndIDBase64"
                control={control}
                render={({field: {onChange, name}}) => (
                  <StyledInputFile>
                    <label style={{cursor: "pointer"}} htmlFor="pAndIDBase64">
                      관련P&ID :
                    </label>
                    <Button variant="contained" component="label" size="small">
                      파일 업로드
                      <TextField
                        sx={{display: "none"}}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                          convertChangeHandler(event, setValue, name, "pAndID")
                        }
                        type="file"
                        id="pAndIDBase64"
                        size="small"
                        hidden
                      />
                    </Button>
                    <p>{getValues("pAndID")}</p>
                    <IconButton
                      aria-label="delete"
                      color="secondary"
                      onClick={() => {
                        setValue("pAndIDBase64", "");
                        setValue("pAndID", "");
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>

                    {/* {errors.pAndIDBase64 && <Typography>{errors.pAndIDBase64.message}</Typography>} */}
                  </StyledInputFile>
                )}
              />
            </Box>
          )}
          {isMobile ? (
            <MWInputFile file="pictureBase64" fileName="picture" buttonLabel="설비사진" />
          ) : (
            <Box sx={{width: "100%"}}>
              <Controller
                name="pictureBase64"
                control={control}
                render={({field: {onChange, name, value}}) => (
                  <StyledInputFile>
                    <label style={{cursor: "pointer"}} htmlFor="pictureBase64">
                      설비사진 :
                    </label>
                    <Button variant="contained" component="label" size="small">
                      이미지 업로드
                      <TextField
                        sx={{display: "none"}}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                          convertChangeHandler(event, setValue, name, "picture")
                        }
                        type="file"
                        id="pictureBase64"
                        label="설비사진"
                        size="small"
                        hidden
                      />
                    </Button>
                    <p>{getValues("picture")}</p>
                    <IconButton
                      aria-label="delete"
                      color="secondary"
                      onClick={() => {
                        setValue("pictureBase64", "");
                        setValue("picture", "");
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                    {/* {errors.pictureBase64 && <Typography>{errors.pictureBase64.message}</Typography>} */}
                  </StyledInputFile>
                )}
              />
            </Box>
          )}
        </InputFileContainer>
      </FormSection>
    </React.Fragment>
  );
};

export default EquipmentForm;
